<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseSelect
          :options="statusSelect.options"
          :data="statusSelect.data"
          ref="statusSelect"
        ></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/files-screen-management/slide-show-add.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow class="row-2">

    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #updateDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}
            </td>
          </template>
          <template #description="{ item }">
            <td>
              <span class="description">{{ item.description }}</span>
            </td>
          </template>
          <template #isCentral="{ item }">
            <td>
              <span class="badge badge-secondary" v-if="item.isCentral == true">Gửi từ nguồn</span>
              <span class="badge badge-secondary" v-else>Biên tập</span>
            </td>
          </template>
          <template #status="{item}">
            <td>
                <span v-if="item.status == 1" class="dot-custom dot-success">
                Đã duyệt
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Hủy duyệt'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_status', item.id, item.title, item.status)"/>
              </span>
              <span v-else class="dot-custom dot-danger">
                Chưa duyệt
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Duyệt'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_status', item.id, item.title, item.status)"/>
              </span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Đồng bộ ngay tới các thiết bị'"
                  @click="setupSelectOneAction('async_to_device', item.id, item.title)"
                  square
                  size="sm">
<!--                  <CIcon name="cil-pencil"/>-->
                  <i class="fa fa-refresh"></i>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  @click="$router.push(`${item.id}/slide-show-update.html`)"
                  square
                  size="sm">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.title)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseSwitch from "@/views/base/BaseSwitch";
import {DatePicker} from "v-calendar";

export default {
  name: "SlideShowList",
  components: {
    BaseFormLoading,
    DatePicker,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    BaseSwitch
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/slide_show/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "trình diễn",
          that.actionData.model.slideShowTitle
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.slideShowId,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa trình diễn " + that.actionData.model.slideShowTitle + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("async_to_device", {
      url: "/slide_show/asyncToDevice",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "đồng bộ",
          "trình diễn",
          that.actionData.model.slideShowTitle + " tới các thiết bị"
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.slideShowId,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Đồng bộ trình diễn " + that.actionData.model.slideShowTitle + " tới các thiết bị thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("update_status", {
      url: "/slide_show/updateStatus",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.status == true ? "HỦY DUYỆT" : "DUYỆT", "trình diễn", that.actionData.model.slideShowTitle);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.slideShowId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: that.actionData.model.status == true ? "Hủy duyệt trình diễn thành công" : "Duyệt trình diễn thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      loading: {
        value: false,
      },
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          slideShowId: null,
          slideShowTitle: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "title",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      statusSelect: {
        options: {
          filter: false,
          label: "Trạng thái",
        },
        data: {
          name: "status",
          items: [
            {key: "-1", value: "Tất cả trạng thái"},
            {key: "0", value: "Chưa duyệt"},
            {key: "1", value: "Đã duyệt"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Ngày tạo"},
            {key: "title", label: "Tiêu đề"},
            // {key: "ratio", label: "Ratio"},
            {key: "status", label: "Trạng thái"},
            {key: "updateDate", label: "Cập nhật cuối"},
            {key: "isCentral", label: "Nguồn trình diễn"},
            {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: [
            "index",
            "createDate",
            "action",
            "status",
            "isCentral",
            "description", "updateDate"
          ],
          pageSize: 15,
          sorter: true,
          columnFilter: false,
          tableFilter: false,
        },
        dataSource: {
          url: "/slide_show/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.slideShowId = fileId || null;
      actionData.slideShowTitle = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
  },
  computed: {},
};
</script>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
